import type { FaireProductEntity } from "../../entity_types/product";

export const p_euddwu9fa4: FaireProductEntity = {
  token: "p_euddwu9fa4",
  type: "product",
  name: "MERCI BIEN - Thank You Card",
  brandToken: "b_2e4a1d49",
  brandName: "Carolyn Suzuki",
  imageUrl:
    "https://cdn.faire.com/fastly/b1660e3707036ce67d316f0644f6585bbffbcbb375237c87554ea9bfee8db46a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf9770e4649fd6902f1c24e222738d9b4435860320d54aff47c56c7923687cb6.png",
    "https://cdn.faire.com/fastly/8d919b29627f2fc53fce477b636a5a64e433f0c3aa5656e0f406028e497591fd.png",
  ],
  priceDollars: 3.25,
  description:
    "Greeting Card, blank inside. A2 Size - 4.25 by 5.5 inches with foil embellishments.\n\nComes with a coordinated envelope and packaged in a clear sleeve.\n\nLovingly designed by Carolyn Suzuki in Los Angeles, California.\n\nMade in Los Angeles U.S.A.",
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:17.811Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
